import { ComputedRef } from 'vue'

import { JudgeDetailPageStateViewModel } from '@/presentation/viewmodels/judgeDetail/judgeDetailPageStateViewModel'

export class JudgeDetailPageStatePresenter {
  private viewModel: JudgeDetailPageStateViewModel

  constructor(viewModel: JudgeDetailPageStateViewModel) {
    this.viewModel = viewModel
  }

  get isHideJudgeCaseList(): ComputedRef<boolean[]> {
    return this.viewModel.isHideJudgeCaseList
  }

  setFlagIsHideJudgeCaseList(index: number, flag: boolean): void {
    this.viewModel.setFlagIsHideJudgeCaseList(index, flag)
  }

  reverseFlagIsHideJudgeCaseList(index: number): void {
    const flag = !this.viewModel.isHideJudgeCaseList.value[index]
    this.viewModel.setFlagIsHideJudgeCaseList(index, flag)
  }

  downloadTestCase = async (problemId: string, index: number, isOutput: boolean): Promise<void> => {
    if (!isOutput) {
      const response = await fetch('https://judgedat.u-aizu.ac.jp/testcases/' + problemId + '/' + index + '/in')
      const blob = await response.blob()
      const newBlob = new Blob([blob])
      const objUrl = window.URL.createObjectURL(newBlob)
      const link = document.createElement('a')
      link.href = objUrl
      link.download = 'in' + index
      link.click()
    } else {
      const response = await fetch('https://judgedat.u-aizu.ac.jp/testcases/' + problemId + '/' + index + '/out')
      const blob = await response.blob()
      const newBlob = new Blob([blob])
      const objUrl = window.URL.createObjectURL(newBlob)
      const link = document.createElement('a')
      link.href = objUrl
      link.download = 'out' + index
      link.click()
    }
  }
}
